import React, { forwardRef } from 'react';

import {
  makeStyles,
  Theme,
  createStyles,
  IconButton,
  Tooltip,
} from '@material-ui/core';

import CloseIcon from '@material-ui/icons/Close';
import { useOriginatorDetail } from 'modules/register/register-api';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    originatorWrapper: {
      display: 'flex',
      flexDirection: 'column',
      color: 'white',
      fontWeight: 'bold',
      fontSize: 16,
      padding: '16px',
    },
    originatorLabel: {
      padding: '0 8px',
      fontSize: 14,
      lineHeight: '24px',
    },
    originatorLabelSubclass: {
      padding: '4px 8px 0 12px',
      fontSize: 13,
      lineHeight: '24px',
      fontWeight: 'normal',
    },
    icon: {
      fontSize: 14,
      margin: `0 ${theme.spacing(1)}px`,
      '&:hover': {
        backgroundColor: 'rgba(255,255,255,0.1)',
      },
    },
    tooltip: {
      fontSize: 12,
    },
  })
);

const OriginatorFilterActive = forwardRef<HTMLDivElement>(
  function OriginatorFilterActive(props, ref) {
    const classes = useStyles();
    const searchParams = new URLSearchParams(window.location.search);
    const originatorId = searchParams.get('originator') ?? undefined;
    const originatorDetail = useOriginatorDetail(originatorId);

    if (!originatorId || !originatorDetail) {
      return null;
    }

    return (
      <div className={classes.originatorWrapper} ref={ref}>
        <div>
          <span>Rejstříkové heslo:</span>
          <Tooltip
            title={<span className={classes.tooltip}>Zrušit filtr</span>}
            placement="top"
          >
            <IconButton
              key="close"
              aria-label="Close"
              color="primary"
              onClick={() => {
                const url = new URL(window.location.href);
                url.searchParams.delete('originator');
                window.location.href = url.toString();
              }}
              className={classes.icon}
            >
              <CloseIcon />
            </IconButton>
          </Tooltip>
        </div>
        <span className={classes.originatorLabel}>
          {originatorDetail.data?.label}
        </span>
        <span className={classes.originatorLabelSubclass}>
          <i>- {originatorDetail.data?.subClassLabel}</i>
        </span>
      </div>
    );
  }
);

export default OriginatorFilterActive;
